// extracted by mini-css-extract-plugin
export default {"button":"headercartbutton_button__h3+sL","icon":"headercartbutton_icon__LvThm","badge":"headercartbutton_badge__ZExOZ","bump":"headercartbutton_bump__khnXz"};